import { createAsyncThunk } from '@reduxjs/toolkit';
import { isAxiosError } from 'axios';
import API from '../../config/api.config';
import {
  AgreementReq,
  AgreementResponce,
  ContractReq,
  ContractResponse,
  RejectValue,
} from './mycar-types';

export const getContractByGuid = createAsyncThunk<
  ContractResponse,
  ContractReq,
  { rejectValue: RejectValue } // Тип для rejectWithValue
>('getcontractbyguid', async (data, thunkAPI) => {
  try {
    const res = await API.post(`mkb/contracts/getcontractbyguid`, data);
    return res.data;
  } catch (error) {
    // console.error('getContractByGuid', error);
    // return thunkAPI.rejectWithValue(error);

    if (isAxiosError(error)) {
      // Возвращаем только сериализуемую информацию об ошибке
      return thunkAPI.rejectWithValue({
        message: error.message,
        code: error.code,
      });
    }
    return thunkAPI.rejectWithValue({
      message: 'Unexpected error',
    });
  }
});

export const saveAgreement = createAsyncThunk<
  AgreementResponce,
  AgreementReq,
  { rejectValue: RejectValue }
>('saveAgreement', async (data, thunkAPI) => {
  try {
    const res = await API.post(`mkb/contracts/mycar-finance/final`, data);
    return res.data;
  } catch (error) {
    console.error(error);
    if (isAxiosError(error)) {
      // Возвращаем только сериализуемую информацию об ошибке
      return thunkAPI.rejectWithValue({
        message: error.message,
        code: error.code,
      });
    }
    return thunkAPI.rejectWithValue({
      message: 'Unexpected error',
    });
  }
});
